export const closeErrorDialog = () => ({
  type: "CLOSE_ERROR_DIALOG",
});
